var _rect, _rect2, _polygon, _line, _circle, _line2, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeparator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 97.1 12.7",
    enableBackground: "new 0 0 97.1 12.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.6,
    y: 3,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 14.7528 -22.8645)",
    fill: "none",
    stroke: "#c98a3a",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    width: 6.8,
    height: 6.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58.7,
    y: 3,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 22.699 -42.0484)",
    fill: "none",
    stroke: "#c98a3a",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    width: 6.8,
    height: 6.8
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#c98a3a",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    points: "48.6,12.1 39.8,6.4 48.6,0.6 57.3,6.4  "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#c98a3a",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    x1: 3.2,
    y1: 6.4,
    x2: 30.2,
    y2: 6.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#c98a3a",
    cx: 2.6,
    cy: 6.4,
    r: 2.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#c98a3a",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    x1: 93.9,
    y1: 6.4,
    x2: 66.9,
    y2: 6.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#c98a3a",
    cx: 94.4,
    cy: 6.4,
    r: 2.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparator);
export default __webpack_public_path__ + "static/media/separator.2db877fa28d05cf0df036094ec5aeee7.svg";
export { ForwardRef as ReactComponent };